const state = {
    head:{
        icon: "https://www.ctrip.com/favicon.ico",
        link: 'http://baoku.360.cn/',
        title: '常用办公软件'
    },
    apps:[
        [
            {
                link:"https://5e4c15b9f19748ac2bfd622dbd60d651.rdt.tfogc.com:49156/dldir1.qq.com/weixin/Windows/WeChatSetup.exe?mkey=639aec871c273b9ad881e0fcd2fcd942&arrive_key=97397708736&cip=183.254.32.190&proto=https",
                img:require('@/assets/images/soft/weixin.png'),
                title:"微信",
                key: 1,
            },
            {
                link:"https://pc-package.wpscdn.cn/wps/download/W.P.S.50.513.exe",
                img:require('@/assets/images/soft/WPS.png'),
                title:"WPS",
                key: 1,
            },
        ],
        [
            {
                link:"https://voice-cdn.shouji.sogou.com/wapdl/hole/202103/19/sogou_pinyin_101a.exe",
                img:require('@/assets/images/soft/sougou.png'),
                title:"搜狗输入法",
                key: 1,
            },
            {
                link:"https://dldir1.qq.com/qqfile/qq/PCQQ9.7.3/QQ9.7.3.28946.exe",
                img:require('@/assets/images/soft/QQ.png'),
                title:"QQ",
                key: 1,
            },
         ],
         [
         {
                link:"http://softdl.360tpcdn.com/auto/20220726/100101893_a6a0f7c173094f8dafef996157751ecf.exe",
                img:require('@/assets/images/soft/7Z.png'),
                title:"7-Zip",
                key: 1,
            },
            {
                link:"https://download-ruanjian.2345.cc/down/2345%E7%9C%8B%E5%9B%BE%E7%8E%8B_100173_0_39022_.exe",
                img:require('@/assets/images/soft/2345kantu.png'),
                title:"2345看图王",
                key: 1,
            },
           ],
           [
            {
                link:"https://softdl6.360tpcdn.com/pcrj/jssetup_72_9510044.exe",
                img:require('@/assets/images/soft/kugou.png'),
                title:"酷狗音乐",
                key: 1,
            },
            {
                link:"https://softdl6.360tpcdn.com/pcrj/jssetup_2000000995_9510044.exe",
                img:require('@/assets/images/soft/tengxunhuiyi.png'),
                title:"腾讯会议",
                key: 1,
            },
        ],
        [
            {
                link:"http://softdl.360tpcdn.com/auto/20220329/100100849_e665d4da0acf10ba0948666db127d8d9.exe",
                img:require('@/assets/images/soft/WinRAR.png'),
                title:"WinRAR压缩",
                key: 1,
            },
            {
                link:"https://dl-cdn.oray.com/sunlogin/windows/SunloginClient_13.1.0.48900_x64.exe",
                img:require('@/assets/images/soft/xiangrikui.png'),
                title:"向日葵远程控制",
                key: 1,
            },
        ]
    ],
}
const mutations = {
    setRightBoxNewsData (state, data) {
        state.data = data
    },
}
const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
